// extracted by mini-css-extract-plugin
export default {"reporting_container":"Reporting_reporting_container__xS7OE"};